import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
  renderRichText,
} from "gatsby-source-contentful/rich-text"

import React from "react"

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <strong>{text}</strong>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <p>{children}</p>,
    [BLOCKS.UL_LIST]: (node, children) => <ul>{children}</ul>,
    [BLOCKS.LIST_ITEM]: (node, children) => <li>{children}</li>,
    [BLOCKS.EMBEDDED_ASSET]: ({ data }) => (
      <img src={data.target.fields.file["en-US"].url} style={styles.img} alt={data.target.fields.description} />
    ),
  },
}

const styles = {
  img: {
    margin: "40px auto",
    width: "100%",
    display: "block",
  },
}

export const richText = (rt: RenderRichTextData<ContentfulRichTextGatsbyReference>) => renderRichText(rt, options)
